import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'src/feature-flags/FlagsHook';

type DefaultTemplatePermission = { canChoose: boolean };

/**
 * Whether the current user can choose the firm's default meeting note template. core-api decides who
 * can, so the controls show for exactly the people it accepts. False until it answers.
 */
export function useCanChooseDefaultTemplate(): boolean {
  const { flagEnabledDefaultTemplates } = useFlags();
  const { data } = useQuery<DefaultTemplatePermission>({
    queryKey: ['templates', 'default-permission'],
    enabled: flagEnabledDefaultTemplates,
  });
  return data?.canChoose ?? false;
}
